
(function ($, document) {
    $(document).ready(function () {
        $(document).on('change', '.js-link-dropdown', function (e) {
            e.preventDefault();
            var url = $(this).find(':selected').val();
            location.href = url;
        });
    });

})(jQuery, document);